import SimpleBar from 'simplebar';
import Cookies from 'js-cookie';

import { getScrollBarWidth } from 'helpers/utils';
import { closeMobileAccount } from './dealer-portal-navigation';

const _dashboard = document.getElementsByClassName('js--db')[0];
const _dashboardOverlay = document.getElementsByClassName('js--db-overlay')[0];
const _nav = document.getElementsByClassName('db-nav')[0];
const _db = document.getElementsByClassName('js--dashboard')[0];
const _toggleBtn = document.getElementsByClassName('js--db-close')[0];

let ss = null;
let ssTimeout = null;

function setCountDownElements() {
    const countDownArray = Array.from(document.getElementsByClassName('js--alert-countdown'));

    for (let i = countDownArray.length - 1; i >= 0; i--) {
        const _this = countDownArray[i];
        const date = new Date();
        const targetDate = Date.parse(_this.getAttribute('data-alert-countdown'));
        const today = Date.parse(`${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`);
        const remainingDays = Math.floor((targetDate - today) / 86400000);
        let countDownStr = `${remainingDays} Days Until Launch!`;

        if (remainingDays < 0) {
            countDownStr = 'Deal Ended';
        } else if (remainingDays < 2) {
            countDownStr =
                remainingDays === 1
                    ? `${remainingDays} Day Until Launch!`
                    : 'Last Day Until Launch!';
        }

        _this.innerHTML = countDownStr;
    }
}

function setScrollWidths() {
    const scrollWidth = getScrollBarWidth();
    const navPaddingRight = parseInt(getComputedStyle(_nav)['padding-right'], 10);
    const paddingRight = `${scrollWidth + navPaddingRight}px`;

    _nav.style.paddingRight = paddingRight;
    ss = new SimpleBar(document.getElementsByClassName('js--db-scroll')[0]);
}

function toggleBtn(cookie) {
    const _navWrapper = document.getElementsByClassName('js--db-nav-wrapper')[0];
    const _content = document.getElementsByClassName('js--db-content')[0];

    _toggleBtn.classList.toggle('db__header--active');
    _dashboard.classList.toggle('db--min');
    _nav.classList.toggle('db-nav--expand');
    _navWrapper.classList.toggle('db-nav__wrapper--expand');
    _content.classList.toggle('dashboard__content--min');

    Array.from(['dashboard--expanded', 'dashboard--min']).forEach((k) => _db.classList.toggle(k));

    if (!cookie) {
        updateDashboardToggleCookie();
    }
}

function toggleMobileDashboard() {
    if (_dashboard.classList.contains('db--min')) {
        _dashboard.classList.remove('db--min');
    }

    closeMobileAccount();

    document.body.classList.toggle('sidecart--open');
    _dashboardOverlay.classList.toggle('db__overlay--active');
    _dashboard.classList.toggle('db--active');
}

function updateResizes() {
    updateScrollBar();
    updateDashboard();
}

function updateScrollBar() {
    clearTimeout(ssTimeout);
    ssTimeout = setTimeout(() => ss.recalculate(), 250);
}

function updateDashboard() {
    if (getComputedStyle(_dashboardOverlay).display === 'none') {
        _dashboard.classList.remove('db--active');
        _dashboardOverlay.classList.remove('db__overlay--active');
        _db.classList.remove('sidecart--open');

        if (_db.classList.contains('dashboard--min')) {
            _dashboard.classList.add('db--min');
        }
    }
}

function checkDashboardToggleCookie() {
    const cookie = Cookies.get('dashboardPosition');

    if (cookie === 'small') {
        toggleBtn('nonUser');
    }
}

function updateDashboardToggleCookie() {
    const cookie = Cookies.get('dashboardPosition');
    const newCookie = cookie === 'small' ? 'large' : 'small';

    Cookies.set('dashboardPosition', newCookie, { expires: 7 });
}

function init() {
    const _dbMobileToggles = Array.from(
        document.querySelectorAll('.js--dbMobile, .js--db-overlay'),
    );

    checkDashboardToggleCookie();
    setCountDownElements();
    setScrollWidths();

    _toggleBtn.addEventListener('click', (e) => {
        e.preventDefault();

        if (getComputedStyle(_dashboardOverlay).display === 'none') {
            return toggleBtn();
        }

        toggleMobileDashboard();
    });

    window.addEventListener('resize', () => updateResizes());

    _dbMobileToggles.forEach((k) =>
        k.addEventListener('click', (e) => {
            e.preventDefault();
            toggleMobileDashboard();
        }),
    );
}

export default init;



// WEBPACK FOOTER //
// ./app/js/modules/dashboard.js